module.exports = __webpack_public_path__ + "static/img/rank_80.6bf5aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_80.png
// module id = TikK
// module chunks = 1